export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-6.f45f869a.svg";